import styled, { css } from 'styled-components';
import { Chevron } from '@solent-university/solent-icons';

import scrollbarStyle from 'Common/styles/scrollbar';

const tabWidths = {
    base: 40,
    mediumSmall: 27.5,
    medium: 20
};

export const TabsWrapper = styled.div<{ $isSticky: boolean }>`
    ${({ theme, $isSticky }) => css`
        border-bottom: 0.0625rem solid rgb(232, 233, 234);
        background: linear-gradient(
            180deg,
            ${theme.colors.secondary.hex} calc(100% - 0.375rem),
            ${theme.colors.secondary.tints[1].hex} calc(100% - 0.375rem)
        );
        /* Fixes issue on Safari where 180 rotation on tabs for mobile scroll causes tabs to be hidden */
        transform: rotateX(0);

        @media ${theme.breakpoints.medium.media} {
            background: ${theme.colors.secondary.hex};
        }

        ${$isSticky &&
        css`
            position: fixed;
            top: 0;
            left: 0;
            right: 0;
            z-index: 501;
        `}
    `}
`;

export const OverflowContainer = styled.div`
    ${({ theme }) => css`
        overflow-x: scroll;
        overflow-y: visible;
        ${scrollbarStyle()}
        transform: rotateX(180deg);
        transform-origin: center;
        padding-top: 0.375rem;
        width: calc(100% + 1.5rem);
        margin-left: -0.75rem;

        ::-webkit-scrollbar-track {
            border: none;
        }

        ::-webkit-scrollbar-thumb {
            background: #8d8d8d;
        }

        @media ${theme.breakpoints.medium.media} {
            overflow: initial;
            padding-top: 0;
            width: 100%;
            margin-left: 0;
        }
    `}
`;

export const Tabs = styled.div`
    position: relative;
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-content: stretch;
    transform: rotateX(180deg);
    transform-origin: center;
`;

export const Tab = styled.button<{ $isActive: boolean }>`
    ${({ theme, $isActive }) => css`
        position: relative;
        background-color: transparent;
        padding: 1.5rem 0.25rem;
        border: none;
        font-size: 1rem;
        width: ${tabWidths.base}%;
        min-width: ${tabWidths.base}%;
        white-space: normal;
        cursor: pointer;

        &:last-child {
            border-right: 0.0625rem solid ${theme.colors.secondary.tints[1].hex};
        }

        ${$isActive &&
        css`
            font-weight: 700;
        `}

        ${!$isActive &&
        css`
            &:hover {
                color: ${theme.colors.primary.hex};

                > ${DownIcon} {
                    display: block;
                }
            }
        `}

        @media ${theme.breakpoints.mediumSmall.media} {
            width: ${tabWidths.mediumSmall}%;
            min-width: ${tabWidths.mediumSmall}%;
        }

        @media ${theme.breakpoints.medium.media} {
            width: ${tabWidths.medium}%;
            min-width: ${tabWidths.medium}%;
        }

        @media ${theme.breakpoints.xlarge.media} {
            font-size: 1.125rem;
            min-width: 12rem;
        }

        @media ${theme.breakpoints.huge.media} {
            font-size: 1.5rem;
        }
    `}
`;

export const DownIcon = styled(Chevron)`
    ${({ theme }) => css`
        display: none;
        color: ${theme.colors.primary.hex};
        width: 0.6rem;
        height: auto;
        position: absolute;
        left: 50%;
        transform: translateX(-50%) rotate(90deg);
    `}
`;

export const TabIndicator = styled.div<{ $activeTabIndex: number }>`
    ${({ theme, $activeTabIndex }) => css`
        position: absolute;
        bottom: 0;
        left: 50%;
        transform: translate(-50%, 50%);
        width: 4.5rem;
        height: 0.75rem;
        border-radius: 0.5rem;
        background: ${theme.colors.accents[3].hex};
        left: calc((${tabWidths.base}% * ${$activeTabIndex}) + ${tabWidths.base / 2}%);
        transition: left 0.25s ease-in-out;

        @media ${theme.breakpoints.mediumSmall.media} {
            left: calc(
                (${tabWidths.mediumSmall}% * ${$activeTabIndex}) + ${tabWidths.mediumSmall / 2}%
            );
        }

        @media ${theme.breakpoints.medium.media} {
            left: calc((${tabWidths.medium}% * ${$activeTabIndex}) + ${tabWidths.medium / 2}%);
        }

        @media ${theme.breakpoints.large.media} {
            width: 6.75rem;
            height: 1rem;
        }
    `}
`;

export const Panel = styled.div`
    position: relative;
`;
